module.exports = __webpack_public_path__ + "img/lip_icon.fcafcfe8.png";